module.exports = __webpack_public_path__ + "img/logo.79753cc5.jpeg";